import React from 'react';
import { textEllipsis } from '../../../shared/utils/constants';

export default function (t) {
  return [
    {
      title: t('general.student'),
      field: 'student',
      cellStyle: textEllipsis,
      render: (rowData) => {
        const { student } = rowData;
        return (
          <span className="tooltip-test" title={student}>
            {student}
          </span>
        );
      },
    },
    {
      title: t('general.classes-names'),
      field: 'classNames',
      cellStyle: textEllipsis,
      render: (rowData) => {
        return (
          <span className="tooltip-test" title={rowData.classNames}>
            {rowData.classNames}
          </span>
        );
      },
    },
    { title: t('general.date'), field: 'formattedDate' },
    { title: t('general.sent'), field: 'formattedSent' },
    {
      title: t('general.audit-status'),
      field: 'auditStatus',
    },
  ];
}
